import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, ParamMap} from "@angular/router";

@Component({
  selector: 'app-video',
  templateUrl: './video.component.html',
  styleUrls: ['./video.component.css']
})
export class VideoComponent implements OnInit {
  private city;

  constructor(private route: ActivatedRoute) { }

  ngOnInit() {


    this.route
      .paramMap
      .subscribe((params: ParamMap) => {
        this.city = params.get('label');
      })
  }

}



// WEBPACK FOOTER //
// ./src/app/video/video.component.ts